<template>
    <vue-scroll :ops="$ops" v-if="isMounted">
    <div v-loading="loading" style="min-height: 600px">
        <div class="card">
            <h3 style="margin-left: 20px">{{year}}年{{monthlyDay}}月</h3>
            <div align="right" style="margin-top: -24px;margin-right: 544px;">
                <el-button-group>
                    <el-button type="success" icon="el-icon-arrow-left" @click="handleLastMonth"
                               :loading="button_loading"></el-button>
                    <el-button type="success" @click="handleToday" :loading="button_loading">今天</el-button>
                    <el-button type="success" @click="handleNextMonth" :loading="button_loading"><i
                            class="el-icon-arrow-right el-icon--right"></i></el-button>
                </el-button-group>
            </div>
            <div class="card-body" style="position: relative;overflow: auto">
                <div v-if='classCell.selectable&&classCell.temp==0' style="position:absolute;margin-left: 1290px;"
                     class="ClassPlanStudent">
                    <ClassPlanStudent :classPlan_id="classCell.classPlan_id" :date="classCell.date"  v-on:listenToChildEvent="showMsgFromChild" ></ClassPlanStudent>
                </div>

                <canvas ref="canvas" v-on:mousedown="handleMouseDown" style="border-top: 0;" @drop='drop($event)'
                        @dragover='allowDrop($event)'
                        :width="rectW*list" :height="row*rectH"
                        :style="{'width':rectW*list/2+'px','height':row*rectH/2+'px'}"></canvas>

                <div v-if='classCell.selectable' class="scell dragging"
                     @click.self="handleCellClick($event)"
                     :style="{'left':classCell.left+'px','top': classCell.top+'px',
                      'height':classCell.height+'px','width': classCell.width+'px'}"
                     draggable="true"
                ></div>
            </div>
        </div>
        <el-dialog
                :title="dialog_title"
                :visible.sync="visible"
                width="350px"
                height="300px"
                :before-close="handleClose"
                append-to-body>
            <component @closeModal="modal=''" :datax="form" v-bind:is="modal" v-on:listenToChildEvent="showMsgFromChild" v-if="visible"></component>
        </el-dialog>


    </div>
    </vue-scroll>
</template>

<script>
    import ClassPlanStudent from './components/ClassPlanStudent'
    import UpdateClassPlan from './components/UpdateClassPlan'
    import UpdateMoreClassPlan from './components/UpdateMoreClassPlan'
    import StoreClassPlan from './components/StoreClassPlan'

    export default {
        name: "OperationMonthly",
        data() {
            return {
                path: "/timeTable/monthly",
                isMounted:false,
                loading: true,
                visible:false,
                dialog_title:'',
                monthlyDay: '',
                now: '',
                year: '',
                class_id: '',
                allClassPlanNumber: '',
                ctx: '',
                timeCtx: '',
                ratio: 2,
                rectW: 180 * 2,
                rectH: 150 * 2,
                list: 7,
                row: 7,
                cell: {
                    position: [0, 0],
                    content: ''
                },
                moveCell: {
                    x: 9,
                    y: 9
                },
                weekCell: ['周一', '周二', '周三', '周四', '周五', '周六', '周日'],
                weekH: 50 * 2,
                dateData: [],
                classPlans: [],
                classPlanDates: [],
                contextMenu: {
                    show: false
                },
                classCell: {},
                modal: '',
                form: {
                    id: '',
                    teacher_id: '',
                    start_time: '',
                    end_time: '',
                    classroom:'',
                    date: '',
                    width: '',
                    height: '',
                    classPlans: [],
                    class_id:'',
                    semester_id:'',
                    class_type_id:'',
                    status:false,
                },
                nowDate: '',
                nextMonth: '',
                lastMonth: '',
                button_loading: false,
                component_classPlanStudent:{
                    classPlan:[],
                    classPlanStudents:[],
                    classPlanCartStudents:[],
                    classPlanCarts:[],
                    classPlanForm: {
                        teacher_id:'',
                        start_time:'',
                        end_time:'',
                        status:'',
                    },
                    teachers: {},
                },
                component_storeClassPlan:{
                    button_loading: false,
                    classPlanForm: {
                        teacher_id:'',
                        duration:'',
                        template_time_semester_id:'',
                        start_time:''
                    },
                    classPlan:[],
                    teachers: [],
                    template_times: [],
                    results:[],
                    sign:[]
                },
                component_updateClassPlan:{
                    button_loading: false,
                    loading: true,
                    classPlanForm: {
                        teacher_id:'',
                        template_time_semester_id:'',
                        start_time:'',
                        end_time:'',
                        status:'',
                        classroom_id:'',
                    },
                    class_type_id:'',
                    classPlan:[],
                    teachers: [],
                    results:[],
                    classrooms: [],
                    sign:[]
                }
            }
        },
        computed: {
            powers(){
                return this.$store.state.config.powers;
            }
        },
        mounted() {
            this.$wApi.addListen(this.path, this.handleData);
            this.handleIndex();
            this.isMounted=true;
        },
        components: {
            'ClassPlanStudent': ClassPlanStudent,
            'UpdateClassPlan': UpdateClassPlan,
            'UpdateMoreClassPlan': UpdateMoreClassPlan,
            'StoreClassPlan': StoreClassPlan,
        },
        methods: {
            handleData(event, data) {
                switch (event) {
                    case 'show':
                        this.dateData = data.dateData;
                        this.classPlans = data.classPlans;
                        this.allClassPlanNumber = data.allClassPlanNumber;
                        this.classPlanDates = data.classPlanDates;
                        this.month =data.month;
                        this.now = data.now;
                        this.year = this.month.substring(0, 4);
                        this.monthlyDay = this.month.substring(5, 7);
                        this.loading = false;
                        this.initCanvas();
                        this.rePainted();
                        break;
                    case 'get_classPlanStudents':
                        this.component_classPlanStudent.classPlanStudents = data.classPlanStudents;
                        this.component_classPlanStudent.classPlan = data.classPlan;
                        this.component_classPlanStudent.classPlanCarts = data.classPlanCarts;
                        this.component_classPlanStudent.classPlanCartStudents = data.classPlanCartStudents;
                        break;
                    case 'get_classPlanContent':
                        this.component_storeClassPlan.teachers = data.teachers;
                        this.component_storeClassPlan.classPlanForm.teacher_id=data.teacher_id;
                        this.component_storeClassPlan.classPlanForm.duration=data.duration;
                        this.component_storeClassPlan.classPlanForm.start_time=data.start_time;
                        break;

                    case 'store_classPlan':
                        if(this.classPlans[data.classPlan.date]){
                            this.$set(this.classPlans[data.classPlan.date],data.classPlan.id,data.classPlan)
                        }else{
                            this.classPlans[data.classPlan.date]={};
                            this.$set(this.classPlans[data.classPlan.date],data.classPlan.id,data.classPlan)
                        }

                        this.component_storeClassPlan.button_loading = false;
                        this.modal='';
                        this.visible=false;
                        this.rePainted();
                        this.classCell.selectable=false;
                        this.$message({
                            message: '新增课时成功',
                            type: 'success'
                        });
                        break;
                    case 'store_classPlan_error':
                        this.component_storeClassPlan.button_loading = false;
                        break;
                    case 'get_classPlanDetail':
                        this.component_updateClassPlan.teachers = data.teachers;
                        this.component_updateClassPlan.results = data.results;
                        this.component_updateClassPlan.classPlanForm.template_time_semester_id=data.classPlan.template_time_semester_id;
                        this.component_updateClassPlan.classPlanForm.classroom_id=data.classPlan.classroom_id;
                        this.component_updateClassPlan.classPlan=data.classPlan;
                        this.component_updateClassPlan.classrooms=data.classrooms;
                        this.component_updateClassPlan.class_type_id=data.class_type_id;
                        this.component_updateClassPlan.loading = false;
                        break;
                    case 'update_classPlan':
                        if(this.classPlans[data.old_date]){
                            this.$delete(this.classPlans[data.old_date],data.old_classPlan_id)
                            if(JSON.stringify(this.classPlans[data.old_date]) == "{}"){
                                this.$delete(this.classPlans,data.old_date)
                            }
                        }
                        if(this.classPlans[data.newClassPlan.date]){
                            this.$set(this.classPlans[data.newClassPlan.date],data.newClassPlan.id,data.newClassPlan)
                        }else{
                            this.classPlans[data.newClassPlan.date]={};
                            this.$set(this.classPlans[data.newClassPlan.date],data.newClassPlan.id,data.newClassPlan)
                        }
                        this.component_updateClassPlan.button_loading = false;
                        this.rePainted();
                        this.classCell.selectable=false;
                        this.modal='';
                        this.visible=false;
                        break;
                    case 'update_classPlan_error':
                        this.component_updateClassPlan.button_loading = false;
                        break;
                    case 'delete_classPlan':
                        this.component_updateClassPlan.button_loading = false;
                        if(this.classPlans[data.date]){
                            this.$delete(this.classPlans[data.date],data.classPlan_id)
                        }
                        if(JSON.stringify(this.classPlans[data.date]) == "{}"){
                            this.$delete(this.classPlans,data.date)
                        }
                        this.modal='';
                        this.visible=false;
                        this.rePainted();
                        this.classCell.selectable=false;
                        this.$message({
                            message: '删除课时成功',
                            type: 'success'
                        });
                        break;
                    case 'delete_classPlan_error':
                        this.component_updateClassPlan.button_loading = false;
                        break;
                    case 'search_classroom':
                        this.component_updateClassPlan.classrooms=data.classrooms;
                        break;
                }
            },
            handleToday() {
                this.nowDate = this.now;
                this.loading = true;
                this.handleIndex()
            },
            handleLastMonth() {
                const hYear = parseInt(this.month.substring(0, 4), 10);
                const hMonthly = parseInt(this.month.substring(5, 7), 10);
                const hDay = parseInt(this.month.substring(5, 7), 10);
                if (hMonthly === 1) {
                    const hMonthly = 12;
                    const hDay = 12;
                    const hYear = parseInt(this.month.substring(0, 4), 10) - 1;
                    this.nowDate = hYear + "-" + hMonthly + "-" + hDay;
                } else {
                    if (hMonthly <= 10) {
                        this.nowDate = hYear + "-" + "0" + (hMonthly - 1) + "-" + "0" + (hDay - 1);
                    } else {
                        this.nowDate = hYear + "-" + (hMonthly - 1) + "-" + hDay;
                    }
                }
                this.loading = true;
                this.handleIndex();
            },
            handleNextMonth() {
                const hYear = parseInt(this.month.substring(0, 4), 10);
                const hMonthly = parseInt(this.month.substring(5, 7), 10);
                const hDay = parseInt(this.month.substring(5, 7), 10);
                if (hMonthly === 12) {
                    const hMonthly = 1;
                    const hDay = 1;
                    const hYear = parseInt(this.month.substring(0, 4), 10) + 1;
                    this.nowDate = hYear + "-" + "0" + hMonthly + "-" + "0" + hDay;
                } else {
                    if (hMonthly <= 8) {
                        this.nowDate = hYear + "-" + "0" + (hMonthly + 1) + "-" + "0" + (hDay + 1);
                    } else {
                        this.nowDate = hYear + "-" + (hMonthly + 1) + "-" + (hDay + 1);
                    }
                }
                this.loading = true;
                this.handleIndex()
            },
            handleIndex() {
                this.class_id = this.$store.state.modal.data.class_id;
                this.$wApi.send(this.path, 'show', {
                    'nowDate': this.nowDate,
                    'class_id': this.class_id,
                });
            },

            initCanvas() {
                const canvas = this.$refs.canvas;
                let ctx = '';
                if (this.ctx) {
                    ctx = this.ctx
                } else {
                    ctx = canvas.getContext('2d');
                    this.ctx = ctx
                }
                this.paintLine(ctx);
                this.paintWeekDay(ctx);
                this.paintDate(ctx);
                this.paintTeacherCell(ctx);
            },
            //画线
            paintLine(ctx) {
                ctx.beginPath();
                ctx.lineWidth = 2;
                ctx.strokeStyle = "#ddd";
                //绘制表格
                // 第一步： 绘制竖线
                for (let i = 0; i <= this.list; i++) {
                    ctx.moveTo(this.rectW * i, 0);
                    ctx.lineTo(this.rectW * i, this.rectH * (this.row - 1) + this.weekH);
                }
                //第二步：绘制横线；
                for (let i = 0; i <= 1; i++) {
                    ctx.moveTo(0, this.weekH * i);
                    ctx.lineTo(this.rectW * this.list, this.weekH * i);
                }

                for (let i = 0; i <= this.row; i++) {
                    ctx.moveTo(0, this.rectH * i + this.weekH);
                    ctx.lineTo(this.rectW * this.list, this.rectH * i + this.weekH);
                }

                ctx.stroke()
            },
            //画出星期几
            paintWeekDay(ctx) {
                const {paintText} = this.weekCell
                ctx.beginPath()
                ctx.font = '600 28px  Microsoft YaHei UI'
                ctx.fillStyle = '#666'
                ctx.textAlign = "center";
                ctx.textBaseline = "middle";
                var i = 0;
                for (const item of this.weekCell) {
                    ctx.fillText(item, i * this.rectW + (this.rectW * 0.5), this.weekH / 2)
                    i++;
                }
                ctx.stroke()
            },
            //画出日期名称、当前日期
            paintDate(ctx) {
                ctx.beginPath();
                ctx.font = '600 28px  Microsoft YaHei UI';
                ctx.textAlign = "right";
                ctx.textBaseline = "top";
                for (const item of this.dateData) {
                    ctx.fillStyle = '#303133';
                    ctx.fillText(item.content + "日", item.position[0] * this.rectW - 25, (item.position[1] - 1) * this.rectH + this.weekH + 10)
                    if (item.date === this.now) {
                        // ctx.fillStyle="#FF0000";
                        ctx.arc(item.position[0] * this.rectW - 70, (item.position[1] - 1) * this.rectH + this.weekH + 27, 20, 0, Math.PI * 2, true);
                        ctx.fillStyle = "rgba(255,0,0,1)";
                        ctx.fill();
                        ctx.fillStyle = "#fff";
                        ctx.fillText(item.content, item.position[0] * this.rectW - 53, (item.position[1] - 1) * this.rectH + this.weekH + 10)
                    }
                }
                ctx.stroke()
            },
            //画出教师、时间信息
            paintTeacherCell(ctx) {
                ctx.beginPath();
                ctx.lineWidth = 1;
                //绘制方格
                for (const item of this.dateData) {
                    const classPlanDate_array = Object.keys(this.classPlans);
                    if (classPlanDate_array.indexOf(item.date) != -1) {
                        let classPlanDate = this.classPlans[item.date];
                        const arr = Object.keys(classPlanDate);
                        if (arr.length == 1) {
                            // ctx.lineJoin = "round";
                            // ctx.lineWidth = 20;
                            ctx.font = '800 20px  Microsoft YaHei UI';
                            ctx.fillStyle = "rgba(255,235,221,0.8)";
                            ctx.fillRect(item.position[0] * this.rectW - this.rectW + 25, (item.position[1] - 1) * this.rectH + this.weekH + 50, this.rectW - 50, (this.rectH - 100) / 2);
                            ctx.fillStyle = "rgba(211,122,63,1)";
                            ctx.fillText("老师：" + classPlanDate[arr[0]].teacherName, item.position[0] * this.rectW - 130, (item.position[1] - 1) * this.rectH + this.weekH + 70);
                            ctx.fillText("上课时间：" + classPlanDate[arr[0]].start_time + "-" + classPlanDate[arr[0]].end_time, item.position[0] * this.rectW - 40, (item.position[1] - 1) * this.rectH + this.weekH + 110)
                        }
                        else if (arr.length == 2) {
                            // ctx.lineJoin = "round";
                            // ctx.lineWidth = 20;
                            ctx.font = '800 20px  Microsoft YaHei UI';
                            ctx.fillStyle = "rgba(255,235,221,0.8)";
                            ctx.fillRect(item.position[0] * this.rectW - this.rectW + 25, (item.position[1] - 1) * this.rectH + this.weekH + 50, this.rectW - 50, (this.rectH - 100) / 2);
                            ctx.fillStyle = "rgba(211,122,63,1)";
                            ctx.fillText("老师：" + classPlanDate[arr[0]].teacherName, item.position[0] * this.rectW - 130, (item.position[1] - 1) * this.rectH + this.weekH + 70);
                            ctx.fillText("上课时间：" + classPlanDate[arr[0]].start_time + "-" + classPlanDate[arr[0]].end_time, item.position[0] * this.rectW - 40, (item.position[1] - 1) * this.rectH + this.weekH + 110)
                            if (classPlanDate[arr[0]].template_time_id !== classPlanDate[arr[1]].template_time_id || classPlanDate[arr[0]].teacher_id !== classPlanDate[arr[1]].teacher_id) {
                                ctx.fillStyle = "rgba(255,235,221,0.8)";
                                ctx.fillRect(item.position[0] * this.rectW - this.rectW + 25, (item.position[1] - 1) * this.rectH + this.weekH + 180, this.rectW - 50, (this.rectH - 100) / 2);
                                ctx.font = '800 20px  Microsoft YaHei UI';
                                ctx.fillStyle = "rgba(211,122,63,1)";
                                ctx.fillText("老师：" + classPlanDate[arr[1]].teacherName, item.position[0] * this.rectW - 130, (item.position[1] - 1) * this.rectH + this.weekH + 200);
                                ctx.fillText("上课时间：" + classPlanDate[arr[1]].start_time + "-" + classPlanDate[arr[1]].end_time, item.position[0] * this.rectW - 40, (item.position[1] - 1) * this.rectH + this.weekH + 240)
                            } else {
                                ctx.fillStyle = 'rgba(244,100,100,1)';
                                ctx.fillRect(item.position[0] * this.rectW - this.rectW + 25-1, (item.position[1] - 1) * this.rectH + this.weekH + 180+2, this.rectW - 50, (this.rectH - 100) / 2);
                                ctx.font = '800 20px  Microsoft YaHei UI';
                                ctx.fillStyle = "rgba(255,239,228,1)";
                                ctx.fillText("老师：" + classPlanDate[arr[1]].teacherName, item.position[0] * this.rectW - 130, (item.position[1] - 1) * this.rectH + this.weekH + 200);
                                ctx.fillText("上课时间：" + classPlanDate[arr[1]].start_time + "-" + classPlanDate[arr[1]].end_time, item.position[0] * this.rectW - 40, (item.position[1] - 1) * this.rectH + this.weekH + 240)
                            }

                        }
                        else if (arr.length > 2) {
                            // ctx.lineJoin = "round";
                            // ctx.lineWidth = 20;
                            ctx.font = '800 30px  Microsoft YaHei UI';
                            ctx.fillStyle = 'rgba(255,235,221,0.8)';
                            ctx.fillRect(item.position[0] * this.rectW - this.rectW + 25, (item.position[1] - 1) * this.rectH + this.weekH + 115, this.rectW - 50, (this.rectH - 100) / 2);
                            ctx.fillStyle = "rgba(211,122,63,1)";
                            ctx.fillText("这天有" + arr.length + "节课", item.position[0] * this.rectW - 100, (item.position[1] - 1) * this.rectH + this.weekH + 150);
                        }
                    }
                }
            },

            handleMouseDown(evt) {
                this.classCell = {};

                const x = evt.offsetX;
                const y = evt.offsetY;


                let cell = {
                    selectable: false,
                    classPlans: [],
                    temp:0,
                    template_time_id: '',
                    start_time: '',
                    end_time: '',
                    teacher_id: '',
                    classPlan_id: '',
                    classroom_id: '',
                    class_id: '',
                    classNumber: '',
                    sign: [],
                    date: '',
                    width: '',
                    status: '',
                    height: ''
                };
                for (const item of this.dateData) {
                    const classPlanDate_array = Object.keys(this.classPlans);
                    if (classPlanDate_array.indexOf(item.date) != -1) {
                        let classPlanDate = this.classPlans[item.date];
                        const arr = Object.keys(classPlanDate);
                        if (arr.length === 1) {
                            if (x >= (item.position[0] * this.rectW - this.rectW + 25) / 2 && x <= (item.position[0] * this.rectW - this.rectW + 25) / 2 + (this.rectW - 50) / 2 && y >= (item.position[1] - 1) * this.rectH / 2 + this.weekH / 2 + 50 - 6 - 25
                                && y <= (item.position[1] - 1) * this.rectH / 2 + this.weekH / 2 + 50 - 6 - 25 + (this.rectH - 100) / 4) {
                                cell.classPlans.push(classPlanDate[arr[0]]);
                                cell.selectable = true;
                                cell.classNumber = 1;
                                cell.classPlan_id = classPlanDate[arr[0]].id;
                                cell.sign = classPlanDate[arr[0]].sign;
                                cell.date = classPlanDate[arr[0]].date;
                                cell.classroom_id = classPlanDate[arr[0]].classroom_id;
                                cell.template_time_id = classPlanDate[arr[0]].template_time_id;
                                cell.start_time = classPlanDate[arr[0]].start_time;
                                cell.end_time = classPlanDate[arr[0]].end_time;
                                cell.teacher_id = classPlanDate[arr[0]].teacher_id;
                                cell.status = classPlanDate[arr[0]].status;
                                cell.left = (item.position[0] * this.rectW - this.rectW + 60) / 2;
                                cell.top = (item.position[1] - 1) * this.rectH / 2 + this.weekH / 2 + 50 - 6;
                                cell.width = (this.rectW - 50) / 2;
                                cell.height = (this.rectH - 100) / 4;
                                this.classCell = cell;
                                break;
                            }
                            if (x >= (item.position[0] * this.rectW - this.rectW + 25) / 2 && x <= (item.position[0] * this.rectW - this.rectW + 25) / 2 + (this.rectW - 50) / 2 && y >= (item.position[1] - 1) * this.rectH / 2 + this.weekH / 2 + 115 - 25
                                && y <= (item.position[1] - 1) * this.rectH / 2 + this.weekH / 2 + 115 - 25 + (this.rectH - 100) / 4) {
                                cell.selectable = true;
                                cell.temp = 1;
                                cell.classNumber = 0;
                                cell.date = item.date;
                                cell.left = (item.position[0] * this.rectW - this.rectW + 60) / 2;
                                cell.top = (item.position[1] - 1) * this.rectH / 2 + this.weekH / 2 + 115 - 6;
                                cell.width = (this.rectW - 50) / 2;
                                cell.height = (this.rectH - 100) / 4;
                                this.classCell = cell;
                                break;
                            }
                        }
                        else if (arr.length == 2) {
                            if (x >= (item.position[0] * this.rectW - this.rectW + 25) / 2 && x <= (item.position[0] * this.rectW - this.rectW + 25) / 2 + (this.rectW - 50) / 2 && y >= (item.position[1] - 1) * this.rectH / 2 + this.weekH / 2 + 50 - 25
                                && y <= (item.position[1] - 1) * this.rectH / 2 + this.weekH / 2 + 50 - 25 + (this.rectH - 100) / 4) {
                                cell.classPlans.push(classPlanDate[arr[0]]);
                                cell.selectable = true;
                                cell.classNumber = 1;
                                cell.classPlan_id = classPlanDate[arr[0]].id;
                                cell.classroom_id = classPlanDate[arr[0]].classroom_id;
                                cell.sign = classPlanDate[arr[0]].sign;
                                cell.date = classPlanDate[arr[0]].date;
                                cell.template_time_id = classPlanDate[arr[0]].template_time_id;
                                cell.start_time = classPlanDate[arr[0]].start_time;
                                cell.end_time = classPlanDate[arr[0]].end_time;
                                cell.teacher_id = classPlanDate[arr[0]].teacher_id;
                                cell.status = classPlanDate[arr[0]].status;
                                cell.left = (item.position[0] * this.rectW - this.rectW + 60) / 2;
                                cell.top = (item.position[1] - 1) * this.rectH / 2 + this.weekH / 2 + 50 - 6;
                                cell.width = (this.rectW - 50) / 2;
                                cell.height = (this.rectH - 100) / 4;
                                this.classCell = cell;
                                break;
                            }
                            if (x >= (item.position[0] * this.rectW - this.rectW + 25) / 2 && x <= (item.position[0] * this.rectW - this.rectW + 25) / 2 + (this.rectW - 50) / 2 && y >= (item.position[1] - 1) * this.rectH / 2 + this.weekH / 2 + 115 - 25
                                && y <= (item.position[1] - 1) * this.rectH / 2 + this.weekH / 2 + 115 - 25 + (this.rectH - 100) / 4) {
                                cell.classPlans.push(classPlanDate[arr[1]])
                                cell.selectable = true;
                                cell.classNumber = 1;
                                cell.classPlan_id = classPlanDate[arr[1]].id;
                                cell.sign = classPlanDate[arr[1]].sign;
                                cell.date = classPlanDate[arr[1]].date;
                                cell.template_time_id = classPlanDate[arr[1]].template_time_id;
                                cell.classroom_id = classPlanDate[arr[0]].classroom_id;
                                cell.start_time = classPlanDate[arr[1]].start_time;
                                cell.end_time = classPlanDate[arr[1]].end_time;
                                cell.teacher_id = classPlanDate[arr[1]].teacher_id;
                                cell.status = classPlanDate[arr[1]].status;
                                cell.left = (item.position[0] * this.rectW - this.rectW + 60) / 2;
                                cell.top = (item.position[1] - 1) * this.rectH / 2 + this.weekH / 2 + 115 - 6;
                                cell.width = (this.rectW - 50) / 2;
                                cell.height = (this.rectH - 100) / 4;
                                this.classCell = cell;
                                break;
                            }
                        }
                        else if (arr.length > 2) {
                            if (x >= (item.position[0] * this.rectW - this.rectW + 25) / 2 && x <= (item.position[0] * this.rectW - this.rectW + 25) / 2 + (this.rectW - 50) / 2 && y >= (item.position[1] - 1) * this.rectH / 2 + this.weekH / 2 + 82 - 25
                                && y <= (item.position[1] - 1) * this.rectH / 2 + this.weekH / 2 + 115 - 25 + (this.rectH - 100) / 4) {
                                for (var i = 0; i < arr.length; i++) {
                                    cell.classPlans.push(classPlanDate[arr[i]])
                                }
                                cell.selectable = true;
                                cell.classNumber = arr.length;
                                cell.classPlan_id = classPlanDate[arr[0]].id;
                                cell.sign = classPlanDate[arr[0]].sign;
                                cell.date = item.date;
                                cell.template_time_id = item.template_time_id;
                                cell.left = (item.position[0] * this.rectW - this.rectW + 60) / 2;
                                cell.top = (item.position[1] - 1) * this.rectH / 2 + this.weekH / 2 + 82 - 6;
                                cell.width = (this.rectW - 50) / 2;
                                cell.height = (this.rectH - 100) / 4;
                                this.classCell = cell;
                                break;
                            }
                        }
                    }else {
                        if (x >= (item.position[0] * this.rectW - this.rectW + 25) / 2 && x <= (item.position[0] * this.rectW - this.rectW + 25) / 2 + (this.rectW - 50) / 2 && y >= (item.position[1] - 1) * this.rectH / 2 + this.weekH / 2 + 50 - 6 - 25
                            && y <= (item.position[1] - 1) * this.rectH / 2 + this.weekH / 2 + 50 - 6 - 25 + (this.rectH - 100) / 4) {
                            cell.selectable = true;
                            cell.temp = 1;
                            cell.classNumber = 0;
                            cell.date = item.date;
                            cell.left = (item.position[0] * this.rectW - this.rectW + 60) / 2;
                            cell.top = (item.position[1] - 1) * this.rectH / 2 + this.weekH / 2 + 50 - 6;
                            cell.width = (this.rectW - 50) / 2;
                            cell.height = (this.rectH - 100) / 4;
                            this.classCell = cell;
                            break;
                        }
                    }
                }

                this.handleCloseClassPlanStudent();
                this.$nextTick(function () {
                    if ( this.classCell.temp != 1) {
                        this.handleOpenClassPlanStudent();
                    }else {
                        this.classCell.selectable = true;
                    }
                })
            },

            showMsgFromChild:function (data){
                this.form.id=data;
                this.classCell.classPlan_id=data;
            },

            handleCloseClassPlanStudent() {
                this.classCell.selectable = false;
            },
            handleOpenClassPlanStudent() {
                this.classCell.selectable = true;
            },

            drop: function (evt) {
                if (this.powers.indexOf(107) != -1) {
                    evt.preventDefault();
                    if (this.classCell.draggable == false)
                        return false;

                    const x = evt.offsetX
                    const y = evt.offsetY

                    for (const item of this.dateData) {
                        const classPlanDate_array = Object.keys(this.classPlans);
                        if (classPlanDate_array.indexOf(item.date) != -1) {
                            let classPlanDate = this.classPlans[item.date];
                            const arr = Object.keys(classPlanDate);
                            if (arr.length == 1) {
                                if (x >= (item.position[0] * this.rectW - this.rectW + 25) / 2 && x <= (item.position[0] * this.rectW - this.rectW + 25) / 2 + (this.rectW - 50) / 2 && y >= (item.position[1] - 1) * this.rectH / 2 + this.weekH / 2 + 50 - 6 - 25
                                    && y <= (item.position[1] - 1) * this.rectH / 2 + this.weekH / 2 + 50 - 6 - 25 + (this.rectH - 100) / 4) {
                                    return this.$message({
                                        message: '不能重叠',
                                        type: 'warning'
                                    });
                                    break;
                                }
                                if (x >= (item.position[0] * this.rectW - this.rectW + 25) / 2 && x <= (item.position[0] * this.rectW - this.rectW + 25) / 2 + (this.rectW - 50) / 2 && y >= (item.position[1] - 1) * this.rectH / 2 + this.weekH / 2 + 115 - 6 - 25
                                    && y <= (item.position[1] - 1) * this.rectH / 2 + this.weekH / 2 + 115 - 6 - 25 + (this.rectH - 100) / 4) {
                                    if (this.classCell.sign.finished_student != 0 || this.classCell.sign.leaving_student != 0 || this.classCell.sign.absent_student != 0) {
                                        return this.$message({
                                            message: '该课时有同学已签过到',
                                            type: 'warning'
                                        });
                                        break;
                                    }
                                    this.form.date = item.date;
                                    this.form.teacher_id = this.classCell.teacher_id;
                                    this.form.start_time = this.classCell.start_time;
                                    this.form.end_time = this.classCell.end_time;
                                    this.form.id = this.classCell.classPlan_id;
                                    this.form.classroom_id = this.classCell.classroom_id;
                                    this.handleSwitchingClassPlan(this.form);
                                    break;
                                }
                            }
                            if (arr.length == 2) {
                                if (x >= (item.position[0] * this.rectW - this.rectW + 25) / 2 && x <= (item.position[0] * this.rectW - this.rectW + 25) / 2 + (this.rectW - 50) / 2 && y >= (item.position[1] - 1) * this.rectH / 2 + this.weekH / 2 + 50 - 6 - 25
                                    && y <= (item.position[1] - 1) * this.rectH / 2 + this.weekH / 2 + 50 - 6 - 25 + (this.rectH - 100) / 4) {
                                    if (this.classCell.sign.finished_student != 0 || this.classCell.sign.leaving_student != 0 || this.classCell.sign.absent_student != 0) {
                                        return this.$message({
                                            message: '该课时有同学已签过到',
                                            type: 'warning'
                                        });
                                    }
                                    this.form.date = item.date;
                                    this.form.teacher_id = this.classCell.teacher_id;
                                    this.form.start_time = this.classCell.start_time;
                                    this.form.end_time = this.classCell.end_time;
                                    this.form.id = this.classCell.classPlan_id;
                                    this.form.classroom_id = this.classCell.classroom_id;
                                    this.handleSwitchingClassPlan(this.form);
                                    break;
                                }
                                if (x >= (item.position[0] * this.rectW - this.rectW + 25) / 2 && x <= (item.position[0] * this.rectW - this.rectW + 25) / 2 + (this.rectW - 50) / 2 && y >= (item.position[1] - 1) * this.rectH / 2 + this.weekH / 2 + 115 - 6 - 25
                                    && y <= (item.position[1] - 1) * this.rectH / 2 + this.weekH / 2 + 115 - 6 - 25 + (this.rectH - 100) / 4) {
                                    if (this.classCell.sign.finished_student != 0 || this.classCell.sign.leaving_student != 0 || this.classCell.sign.absent_student != 0) {
                                        return this.$message({
                                            message: '该课时有同学已签过到',
                                            type: 'warning'
                                        });
                                    }
                                    this.form.date = item.date;
                                    this.form.teacher_id = this.classCell.teacher_id;
                                    this.form.start_time = this.classCell.start_time;
                                    this.form.end_time = this.classCell.end_time;
                                    this.form.id = this.classCell.classPlan_id;
                                    this.form.classroom_id = this.classCell.classroom_id;
                                    this.handleSwitchingClassPlan(this.form);
                                    break;
                                }
                            }
                            if (arr.length > 2) {
                                if (x >= (item.position[0] * this.rectW - this.rectW + 25) / 2 && x <= (item.position[0] * this.rectW - this.rectW + 25) / 2 + (this.rectW - 50) / 2 && y >= (item.position[1] - 1) * this.rectH / 2 + this.weekH / 2 + 82 - 25
                                    && y <= (item.position[1] - 1) * this.rectH / 2 + this.weekH / 2 + 115 - 25 + (this.rectH - 100) / 4) {
                                    if (this.classCell.sign.finished_student != 0 || this.classCell.sign.leaving_student != 0 || this.classCell.sign.absent_student != 0) {
                                        return this.$message({
                                            message: '该课时有同学已签过到',
                                            type: 'warning'
                                        });
                                    }
                                    this.form.date = item.date;
                                    this.form.teacher_id = this.classCell.teacher_id;
                                    this.form.start_time = this.classCell.start_time;
                                    this.form.end_time = this.classCell.end_time;
                                    this.form.id = this.classCell.classPlan_id;
                                    this.form.classroom_id = this.classCell.classroom_id;
                                    this.handleSwitchingClassPlan(this.form);
                                    break;
                                }
                            }
                        }else {
                            if (x >= (item.position[0] * this.rectW - this.rectW + 25) / 2 && x <= (item.position[0] * this.rectW - this.rectW + 25) / 2 + (this.rectW - 50) / 2 && y >= (item.position[1] - 1) * this.rectH / 2 + this.weekH / 2 + 50 - 6 - 25
                                && y <= (item.position[1] - 1) * this.rectH / 2 + this.weekH / 2 + 50 - 6 - 25 + (this.rectH - 100) / 4) {
                                if (this.classCell.sign.finished_student !== 0 || this.classCell.sign.leaving_student !== 0 || this.classCell.sign.absent_student !== 0) {
                                    return this.$message({
                                        message: '该课时有同学已签过到',
                                        type: 'warning'
                                    });
                                }
                                this.form.date = item.date;
                                this.form.teacher_id = this.classCell.teacher_id;
                                this.form.start_time = this.classCell.start_time;
                                this.form.end_time = this.classCell.end_time;
                                this.form.id = this.classCell.classPlan_id;
                                this.form.classroom_id = this.classCell.classroom_id;
                                this.handleSwitchingClassPlan(this.form);
                                break;
                            }
                        }
                    }
                }else{
                    this.$message({
                        message: '没有调课权限',
                        type: 'warning'
                    });
                }

            },
            handleSwitchingClassPlan(form){
                this.$confirm('确定调换?', '提示', {
                    StartReturn: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                }).then(() => {
                    this.$wApi.send(this.path, 'update_classPlan', {
                        'classPlan_id': form.id,
                        'teacher_id': form.teacher_id,
                        'start_time': form.start_time,
                        'end_time': form.end_time,
                        'classroom_id': form.classroom_id,
                        'date':form.date,
                    });
                }).catch(() => {
                    this.$message({
                        type: 'info',
                        message: '已取消'
                    });
                });

            },
            allowDrop: function (event) {
                event.preventDefault();
                return true;
            },
            handleCellClick() {
                if (this.classPlans[this.classCell.date]&&this.classCell.temp==0&&this.powers.indexOf(105) != -1) {
                    this.form.classPlans = this.classCell.classPlans;
                    this.form.teacher_id = this.classCell.teacher_id;
                    this.form.template_time_id = this.classCell.template_time_id;
                    this.form.start_time = this.classCell.start_time;
                    this.form.end_time = this.classCell.end_time;
                    this.form.id = this.classCell.classPlan_id;
                    this.form.date = this.classCell.date;
                    this.form.classroom_id = this.classCell.classroom_id;
                    this.form.class_id = this.$store.state.modal.data.class_id;
                    this.form.status = false;
                    this.dialog_title='修改课时';
                    this.visible=true;
                    this.modal = 'UpdateClassPlan'
                }

                if (this.classPlans[this.classCell.date] && this.classCell.classNumber > 2) {
                    this.form.classPlans = this.classCell.classPlans;
                    this.form.date = this.classCell.date;
                    this.form.width = this.classCell.width;
                    this.form.height = this.classCell.height;
                    this.form.classroom_id = this.classCell.classroom_id;
                    this.form.class_id = this.$store.state.modal.data.class_id;
                    this.visible=true;
                    // this.form.teacher_id=this.classCell.teacher_id;
                    // this.form.start_time=this.classCell.start_time;
                    // this.form.end_time=this.classCell.end_time;
                    // this.form.id=this.classCell.classPlan_id;
                    this.dialog_title='修改多课时';
                    this.modal = 'UpdateMoreClassPlan'
                }
                if (this.classCell.temp==1 &&this.powers.indexOf(104) != -1){
                    this.form.date = this.classCell.date;
                    this.form.class_id = this.class_id;
                    this.dialog_title='创建课时';
                    this.visible=true;
                    this.modal = 'StoreClassPlan'
                }

            },
            /**
             * 重新绘制
             */
            rePainted() {
                this.clearPainted();
                this.paintLine(this.ctx);
                this.paintWeekDay(this.ctx);
                this.paintDate(this.ctx);
                this.paintTeacherCell(this.ctx)
            },
            /**
             * 清空画布
             */
            clearPainted() {
                this.ctx.clearRect(0, 0, this.list * this.rectW, this.row * this.rectH)
            },
            handleClose(done) {
                done();
            }
        },

    }
</script>

<style scoped>
    .subjectcontent {
        position: relative;
        float: left;
        margin: 0 2px;
    }

    .scell {
        display: table;
        position: absolute;
        background: transparent;
        color: #555;
        z-index: 50;
        width: 98px;

        border: 2px solid #000000;
        border-radius: 2px;
    }

    .scell span {

        display: table-cell;
        vertical-align: middle;
        text-align: center;
        font-size: 12px;
        line-height: 15px;
        font-weight: 400;
        font-family: 'Microsoft Yahei UI';
    }

    .studentCell {
        display: table;
        position: absolute;
        background: transparent;
        color: #555;
        z-index: 1200;
        width: 44px;
        height: 20px;
        border: 2px solid #000000;
        border-radius: 2px;
    }
    .withRightBar {
        margin-right: 400px;
    }

    .rightBar {
        box-shadow: -30px 0px 30px -30px rgba(0, 0, 0, 0.2);
        position: absolute;
        top: 0;
        right: 0;
        width: 400px;
        height: 100%;
    }
</style>
